
import { css } from 'lit';
export default css`
.accordion {

  list-style-type: none;

  padding: 0px;
}

  .accordion__title {

  border-bottom-width: 2px
}

  .accordion__title {

  --tw-border-opacity: 1;

  border-color: rgba(35, 35, 35, var(--tw-border-opacity))
}

  .accordion__title {

  padding-bottom: 1.5rem
}
`;